module.exports = __webpack_public_path__ + "img/icb-opening-05.20b48494.png";